import * as Yup from 'yup'
import { REFUND_METHOD, RESOLUTION_ACTION } from 'domains/customer-refund/constants'

const customerRefundAcceptFormSchema = Yup.object().shape(
  {
    refund_method: Yup.string()
      .oneOf(Object.values(REFUND_METHOD),'invalid refund method')
      .required('refund method required'),
    resolution_action: Yup.string()
      .oneOf(Object.values(RESOLUTION_ACTION),'invalid resolution action')
      .required('resolution action required')
  }
)

export default customerRefundAcceptFormSchema
